import { formatInTimeZone, fromZonedTime } from 'date-fns-tz';

// Convert user input (date + time + timezone) to UTC for storage
export const userInputToUTC = (dateString, timeString, timezone = 'America/New_York') => {
  try {
    // Create a date-time string in the specified timezone
    const dateTimeString = `${dateString}T${timeString}:00`;
    
    // Use date-fns-tz to properly convert from the specified timezone to UTC
    const utcDate = fromZonedTime(dateTimeString, timezone);
    return utcDate.toISOString();
  } catch (error) {
    console.error('Error converting to UTC:', error);
    // Fallback: treat as local time
    return new Date(`${dateString}T${timeString}:00`).toISOString();
  }
};

// Format UTC date for display in Eastern Time
export const formatAsEasternTime = (utcDateString) => {
  try {
    const utcDate = new Date(utcDateString);
    return formatInTimeZone(utcDate, 'America/New_York', 'h:mm a');
  } catch (error) {
    console.error('Error formatting Eastern Time:', error);
    return new Date(utcDateString).toLocaleTimeString('en-US', { 
      timeZone: 'America/New_York',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true 
    });
  }
};

// Format UTC date for display in user's local time
export const formatAsLocalTime = (utcDateString) => {
  try {
    const utcDate = new Date(utcDateString);
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return formatInTimeZone(utcDate, userTimezone, 'h:mm a');
  } catch (error) {
    console.error('Error formatting local time:', error);
    return new Date(utcDateString).toLocaleTimeString();
  }
};

// Format UTC date for display as full date in Eastern Time
export const formatAsEasternDate = (utcDateString) => {
  try {
    const utcDate = new Date(utcDateString);
    return formatInTimeZone(utcDate, 'America/New_York', 'EEEE, MMMM d, yyyy');
  } catch (error) {
    console.error('Error formatting Eastern date:', error);
    return new Date(utcDateString).toLocaleDateString('en-US', { 
      timeZone: 'America/New_York',
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
}; 